import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const StatsBar = () => {
  const stats = [
    { value: '+25', label: 'Años de experiencia', desc: 'Desde el año 2000' },
    { value: '+300', label: 'Proyectos ejecutados', desc: 'A nivel nacional' },
    { value: '20+', label: 'Ciudades', desc: 'Cobertura Chile' },
    { value: '4.5★', label: 'Google Reviews', desc: 'Calificación clientes' },
  ];

  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="bg-[#0C1D2E] border-y border-white/10">
      <div ref={ref} className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-white/10">
          {stats.map((stat, i) => (
            <div
              key={stat.label}
              className={`py-10 md:py-12 px-4 md:px-6 text-center reveal ${isVisible ? 'reveal-visible' : ''} reveal-delay-${(i + 1) * 100}`}
            >
              <div className="text-3xl md:text-4xl font-heading font-bold text-white mb-1">
                {stat.value}
              </div>
              <div className="text-white/70 text-sm font-semibold uppercase tracking-wide mb-0.5">
                {stat.label}
              </div>
              <div className="text-white/40 text-xs">
                {stat.desc}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsBar;